var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdownIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.475 10.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drop_down_icon",
    transform: "translate(0 7)",
    fill: "#455689",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.23741436004639 2.637428045272827 L 1.371460437774658 -6.500002861022949 L 23.10336875915527 -6.500002861022949 L 12.23741436004639 2.637428045272827 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.23741436004639 1.984130620956421 L 21.73190307617188 -6.000002861022949 L 2.742926597595215 -6.000002861022949 L 12.23741436004639 1.984130620956421 M 12.23741436004639 3.290717124938965 L 4.360046204965329e-06 -7.000002861022949 L 24.47482490539551 -7.000002861022949 L 12.23741436004639 3.290717124938965 Z",
    stroke: "none",
    fill: "#979797"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/dropdown_icon.04879a74cea18a72598719cc22753264.svg";
export { ForwardRef as ReactComponent };